import { useQuery } from "react-query";

import axios, { AxiosError } from "axios";
import { DATA_SVC_RS_ADDRESS } from "constants/app.constants";

const API_URL = `${DATA_SVC_RS_ADDRESS}/api/v1/midstream/sales-facility`;

const GetSalesFacilityKey = "sales-facility";

export interface FacilityFraction {
  facilityId: string;
  gasPct: number;
}

const fetchSalesFacilities = async (wellId?: string) => {
  if (!wellId) {
    return Promise.resolve([]);
  }
  const response = await axios.get<FacilityFraction[]>(`${API_URL}/${wellId}`);
  return response.data;
};

const useGetSalesFacilityFromWell = (wellId?: string) => {
  return useQuery<FacilityFraction[], AxiosError>(
    [GetSalesFacilityKey, wellId],
    () => fetchSalesFacilities(wellId),
    {
      refetchOnWindowFocus: false,
      enabled: !!wellId
    }
  );
};

export default useGetSalesFacilityFromWell;
